<form id="confirmForm">
  <dialog-header>{{title}}</dialog-header>
  <mat-dialog-content>
    <p class="align-left" [innerHTML]="message"></p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-4">
    <div class="tw-flex-1">
      <button id="cancelButton" mat-stroked-button type="button" class="w-full" (click)="close()">
        {{cancelButton}}
      </button>
    </div>
    <div class="tw-flex-1">
      <button mat-flat-button type="button" color="{{confirmButtonClass}}" id="confirm-primary" class="w-full" (click)="confirm()">
        <span>{{confirmButton}}</span>
      </button>
    </div>
  </mat-dialog-actions>
</form>
  